import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=3c1d977c&scoped=true&"
import script from "./Outbox.vue?vue&type=script&lang=js&"
export * from "./Outbox.vue?vue&type=script&lang=js&"
import style0 from "./Outbox.vue?vue&type=style&index=0&id=3c1d977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d977c",
  null
  
)

export default component.exports